<script setup lang="ts">
// The single four-point sparkle the design uses to mark a value read from the
// seller's documents. PrimeIcons' `pi-sparkles` is a cluster of three stars,
// which reads as "AI magic" rather than "read from your deed". `outlined` draws
// the hollow variant the legend line uses ("✧ = read from your documents").
defineOptions({ inheritAttrs: false })

withDefaults(defineProps<{ outlined?: boolean }>(), { outlined: false })
</script>

<template>
  <svg
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    :fill="outlined ? 'none' : 'currentColor'"
    :stroke="outlined ? 'currentColor' : 'none'"
    stroke-width="1.25"
    stroke-linejoin="round"
    v-bind="$attrs"
  >
    <path
      d="M8 1.5C8.4 5.2 10.8 7.6 14.5 8C10.8 8.4 8.4 10.8 8 14.5C7.6 10.8 5.2 8.4 1.5 8C5.2 7.6 7.6 5.2 8 1.5Z"
    />
  </svg>
</template>
